import { AbstractControl } from '@angular/forms';

export function emailValidates(control: AbstractControl) {
  if (control.value.additionalEmails.map(data => data.emailAddresses).includes(control.value.primaryEmail)) {
    return { validEmail: true };
  } else {
    return null;
  }

}

export function phoneNumberValidates(control: AbstractControl) {
  if (control.value.additionalPhone.map(data => data.number).includes(control.value.primaryPhone)) {
    return { validMobile: true };
  } else {
    return null;
  }

}
